<div>Import Warehouse Booking:</div>
<input #fileUploadSimple [accept]="'.csv'" type="file" class="file-input" 
  (change)="importDataFromCSV($event)" hidden="true">
<button class="btn btn-sm btn-primary" (click)="resetFileUpload();fileUploadSimple.click()"> Upload CSV File</button> 
<br>


<!-- <div *ngIf="importedData.length > 0">data from csv</div>
<div *ngFor="let item of importedData"> {{item | json}}</div>
 -->

 <div *ngIf="importedData.length > 0" class="mt-2">
    <button class="btn btn-sm btn-danger w-200p mb-1" [hidden]="submitted" (click)="processForm(importedData)" ><span>Import All</span></button> &nbsp;
    <button type="button" [disabled]="!selected || selected.length < 0" class="btn btn-sm btn-secondary" (click)="processForm(selected)">Import Selected</button>
</div>
<form [formGroup]="whFrm" novalidate  (keydown.enter)="$event.preventDefault()">
<input type="hidden" formControlName="orderType">
<div class="card card-header mt-3 mb-3">
  <div class="card-body">
    <div class="row col-md-12 text-left">
      <button type="button" (click)="setOrderType(ORDER_TYPE.SALES)"
          class="btn btn-sm btn-rounded btn-secondary w-300p mb-1"
          [class.btn-secondary]="getOrderType() !== ORDER_TYPE.SALES"
          [class.btn-success]="getOrderType() === ORDER_TYPE.SALES" [disabled]="!enableOrderTypeSelector">
          {{ ORDER_TYPE_LABEL.SALES }}
      </button>
      <button type="button" (click)="setOrderType(ORDER_TYPE.PURCHASE)"
          class="btn btn-sm btn-rounded btn-secondary w-300p mb-1 ml-2"
          [class.btn-secondary]="getOrderType() !== ORDER_TYPE.PURCHASE"
          [class.btn-success]="getOrderType() === ORDER_TYPE.PURCHASE" [disabled]="!enableOrderTypeSelector">
          {{ ORDER_TYPE_LABEL.PURCHASE }}
      </button>
      <button type="button" (click)="setOrderType(ORDER_TYPE.CUSTOM)"
          class="btn btn-sm btn-rounded btn-secondary w-300p mb-1 ml-2"
          [class.btn-secondary]="getOrderType() !== ORDER_TYPE.CUSTOM"
          [class.btn-success]="getOrderType() === ORDER_TYPE.CUSTOM">
          {{ ORDER_TYPE_LABEL.CUSTOM }}
      </button>
  </div>
  </div>
  
  <div class="row pt-2 pb-2">
    <div class="col-md-6">
      Warehouse: <span class="text-danger">*</span>
      <div class="input-group" >
          <select class="form-control form-control-sm" formControlName="whSiteId" (change)="selectWarehouse($event)">
              <option disabled value="0" >Select warehouse</option>
              <option *ngFor="let wh of warehouses" value="wh.id">{{wh.name}} - {{wh.text}}</option>
          </select>
      </div>
  </div>
  </div>
</div>

</form>
<div>
  <ngx-loading [show]="loadingIndicator"></ngx-loading>

  <ngx-datatable #consignmentsTable *ngIf="importedData.length > 0"
    class="material"
    [rows]="importedData"
    [columnMode]="'force'"
    [headerHeight]="30"
    [footerHeight]="40"
    [rowHeight]="'auto'"
    [limit]="50"
    [selected]="selected"
    [selectionType]="sType" 
    [scrollbarH]="true"
    [displayCheck]="displayCheck"
    
    >
    
    <!-- Row Detail Template -->
    <ngx-datatable-row-detail [rowHeight]="'auto'" #myDetailRow (toggle)="onDetailToggle($event)">
      <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
          <div style="padding-left:45px;">
              <div class="row">
                <table class="table table-striped" style="width: 400px;">
                  <thead>
                      <tr>
                          <th style="width: 40px;"></th>
                          <th style="width: 90px;">Items</th>
                          <th style="width: 90px;">Length</th>
                          <th style="width: 90px;">Width</th>
                          <th style="width: 90px;">Height</th>
                          <th style="width: 90px;">Type</th>
                          <th style="width: 90px;">Instructions</th>


                      </tr>
                  </thead>
                  <tbody>
                      <tr *ngFor="let f of row.freights">
                          <td style="width: 40px;"><font color="red"><i class="fa fa-cube"></i></font></td>
                          <td style="width: 90px;">{{f.ITEMS}}</td> 
                          <td style="width: 90px;">{{f.LENGTH}}</td> 
                          <td style="width: 90px;">{{f.WIDTH}}</td> 
                          <td style="width: 90px;">{{f.HEIGHT}}</td>     
                          <td style="width: 90px;">{{f.PACKAGING}}</td>      
                          <td style="width: 90px;">{{f.INSTRUCTIONS}}</td>                       
                 
                  
                      </tr>
      
                  </tbody>
              </table>
              </div>


          </div>
      </ng-template>
  </ngx-datatable-row-detail>

    <ngx-datatable-column [width]="30" [resizeable]="false" [sortable]="false" [draggable]="false"
  [canAutoResize]="false">
      <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
          <a href="javascript:void(0)" [class.datatable-icon-right]="!expanded"
              [class.datatable-icon-down]="expanded" title="Expand/Collapse Row"
              (click)="toggleExpandRow(row)">
          </a>
      </ng-template>
  </ngx-datatable-column>

    <ngx-datatable-column
            [width]="30"
            [sortable]="false"
            [canAutoResize]="false"
            [draggable]="false"
            [resizeable]="false"
            [headerCheckboxable]="!submitted"
            [checkboxable]="true"
          >
          </ngx-datatable-column>
    
        <ngx-datatable-column prop="CONSIGNMENT" name="Consignment" headerClass="header" [width]="180" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-CONSIGNMENT'] = true"
              *ngIf="!editing[rowIndex + '-CONSIGNMENT'] && !isEmpty(value)"
            >
              {{ value }}<br /><b><i>{{row.message}}</i></b>
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-CONSIGNMENT'] = true"
              *ngIf="!editing[rowIndex + '-CONSIGNMENT'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'CONSIGNMENT', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'CONSIGNMENT', rowIndex);false"
              *ngIf="editing[rowIndex + '-CONSIGNMENT']"
              type="text"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="CLIENT" name="Customer" headerClass="header" [width]="180" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-CLIENT'] = true"
              *ngIf="!editing[rowIndex + '-CLIENT'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-CLIENT'] = true"
              *ngIf="!editing[rowIndex + '-CLIENT'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'CLIENT', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'CLIENT', rowIndex);false"
              *ngIf="editing[rowIndex + '-CLIENT']"
              type="text"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>
      
        <ngx-datatable-column prop="pickupCompany" name="Pickup Company" headerClass="header" [width]="180" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-pickupCompany'] = true"
              *ngIf="!editing[rowIndex + '-pickupCompany'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-pickupCompany'] = true"
              *ngIf="!editing[rowIndex + '-pickupCompany'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'pickupCompany', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'pickupCompany', rowIndex);false"
              *ngIf="editing[rowIndex + '-pickupCompany']"
              type="text"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column prop="pickupDate" name="Pickup Date" headerClass="header" [width]="180" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-pickupDate'] = true"
              *ngIf="!editing[rowIndex + '-pickupDate'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-pickupDate'] = true"
              *ngIf="!editing[rowIndex + '-pickupDate'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'pickupDate', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'pickupDate', rowIndex);false"
              *ngIf="editing[rowIndex + '-pickupDate']"
              type="text"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="pickupTime" name="Pickup Time" headerClass="header" [width]="180" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-pickupTime'] = true"
              *ngIf="!editing[rowIndex + '-pickupTime'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-pickupTime'] = true"
              *ngIf="!editing[rowIndex + '-pickupTime'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'pickupTime', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'pickupTime', rowIndex);false"
              *ngIf="editing[rowIndex + '-pickupTime']"
              type="text"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="pickup" name="Pickup" headerClass="header" [width]="180" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-pickup'] = true"
              *ngIf="!editing[rowIndex + '-pickup'] && !isEmpty(value)"
            >
              <span [hidden]="!row.pickupLocationId"><i class="fa fa-lg fa-home text-primary"></i>&nbsp;</span>{{ value }}&nbsp;
              <span title="Click to insert warehouse address" (click)="insertWarehouse('pickup',rowIndex)"><i class="fa fa-sm fa-home  text-secondary"></i></span>
            </span>
           <!--  <span
              title="Warehouse location"
              *ngIf="row.pickupLocationId"
            >
            <i class="fa fa-lg fa-home"></i>&nbsp;{{ value }}
            </span> -->
            <a title="Click to add"
              (click)="editing[rowIndex + '-pickup'] = true"
              *ngIf="!editing[rowIndex + '-pickup'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'pickup', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'pickup', rowIndex);false"
              *ngIf="editing[rowIndex + '-pickup']"
              type="text"
              [value]="value"
            />
           
            
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="ATL1" name="Pickup ATL" headerClass="header" [width]="180" [cellClass]="getCellClass" *ngIf="is_atl">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-ATL1'] = true"
              *ngIf="!editing[rowIndex + '-ATL1'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-ATL1'] = true"
              *ngIf="!editing[rowIndex + '-ATL1'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <select *ngIf="editing[rowIndex + '-ATL1']" (change)="updateValue($event, 'ATL1', rowIndex);" (keyup)="updateValue($event, 'ATL1', rowIndex);"
              (blur)="updateValue($event, 'ATL1', rowIndex)" (keydown.enter)="$event.target.blur();updateValue($event, 'ATL1', rowIndex);false">
              <option value="">N/A</option>
              <option value="YES">Yes</option>
              <option value="NO">No</option>
            </select>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="PREMISE_TYPE1" name="Pickup Premise Type" headerClass="header" [width]="180" [cellClass]="getCellClass" *ngIf="is_premise_type">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-PREMISE_TYPE1'] = true"
              *ngIf="!editing[rowIndex + '-PREMISE_TYPE1'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-PREMISE_TYPE1'] = true"
              *ngIf="!editing[rowIndex + '-PREMISE_TYPE1'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <select *ngIf="editing[rowIndex + '-PREMISE_TYPE1']" (change)="updateValue($event, 'PREMISE_TYPE1', rowIndex)" (keyup)="updateValue($event, 'PREMISE_TYPE1', rowIndex)"
              (blur)="updateValue($event, 'PREMISE_TYPE1', rowIndex)" (keydown.enter)="$event.target.blur();updateValue($event, 'PREMISE_TYPE1', rowIndex);false">
              <option *ngFor="let pt of premise_types" [value]="pt.name">{{pt.name}}</option>
            </select>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="TAIL_LIFT1" name="Pickup Tail Lift" headerClass="header" [width]="180" [cellClass]="getCellClass" *ngIf="is_tail_lift">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-TAIL_LIFT1'] = true"
              *ngIf="!editing[rowIndex + '-TAIL_LIFT1'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-TAIL_LIFT1'] = true"
              *ngIf="!editing[rowIndex + '-TAIL_LIFT1'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <select *ngIf="editing[rowIndex + '-TAIL_LIFT1']" (change)="updateValue($event, 'TAIL_LIFT1', rowIndex)" (keyup)="updateValue($event, 'TAIL_LIFT1', rowIndex)"
              (blur)="updateValue($event, 'TAIL_LIFT1', rowIndex)" (keydown.enter)="$event.target.blur();updateValue($event, 'TAIL_LIFT1', rowIndex);false">
              <option value="">N/A</option>
              <option value="YES">Yes</option>
              <option value="NO">No</option>
            </select>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="deliveryCompany" name="Delivery Company" headerClass="header" [width]="180" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-deliveryCompany'] = true"
              *ngIf="!editing[rowIndex + '-deliveryCompany'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-deliveryCompany'] = true"
              *ngIf="!editing[rowIndex + '-deliveryCompany'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'deliveryCompany', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'deliveryDate', rowIndex);false"
              *ngIf="editing[rowIndex + '-deliveryCompany']"
              type="text"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="deliveryDate" name="Delivery Date" headerClass="header" [width]="180" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-deliveryDate'] = true"
              *ngIf="!editing[rowIndex + '-deliveryDate'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-deliveryDate'] = true"
              *ngIf="!editing[rowIndex + '-deliveryDate'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'deliveryDate', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'pickupCompany', rowIndex);false"
              *ngIf="editing[rowIndex + '-deliveryDate']"
              type="text"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="deliveryTime" name="Delivery Time" headerClass="header" [width]="180" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-deliveryTime'] = true"
              *ngIf="!editing[rowIndex + '-deliveryTime'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-deliveryTime'] = true"
              *ngIf="!editing[rowIndex + '-deliveryTime'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'deliveryTime', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'deliveryTime', rowIndex);false"
              *ngIf="editing[rowIndex + '-deliveryTime']"
              type="text"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>



        <ngx-datatable-column prop="delivery" name="Delivery" headerClass="header" [width]="180" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-delivery'] = true"
              *ngIf="!editing[rowIndex + '-delivery'] && !isEmpty(value)"
            >
              <span [hidden]="!row.deliveryLocationId"><i class="fa fa-lg fa-home text-primary"></i>&nbsp;</span>
              {{ value }}&nbsp;
              <span title="Click to insert warehouse address" (click)="insertWarehouse('delivery',rowIndex)"><i class="fa fa-sm fa-home text-secondary"></i></span>
            </span>
<!--             <span
              title="Warehouse location"
              *ngIf="row.deliveryLocationId"
            >
            <i class="fa fa-lg fa-home"></i>&nbsp;{{ value }}
            </span> -->
            <a title="Click to add"
              (click)="editing[rowIndex + '-delivery'] = true"
              *ngIf="!editing[rowIndex + '-delivery'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'delivery', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'delivery', rowIndex);false"
              *ngIf="editing[rowIndex + '-delivery']"
              type="text"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="ATL2" name="Delivery ATL" headerClass="header" [width]="180" [cellClass]="getCellClass" *ngIf="is_atl">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-ATL2'] = true"
              *ngIf="!editing[rowIndex + '-ATL2'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-ATL2'] = true"
              *ngIf="!editing[rowIndex + '-ATL2'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <select *ngIf="editing[rowIndex + '-ATL2']" (change)="updateValue($event, 'ATL2', rowIndex)" (keyup)="updateValue($event, 'ATL2', rowIndex)"
              (blur)="updateValue($event, 'ATL2', rowIndex)" (keydown.enter)="$event.target.blur();updateValue($event, 'ATL2', rowIndex);false">
              <option value="">N/A</option>
              <option value="YES">Yes</option>
              <option value="NO">No</option>
            </select>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="PREMISE_TYPE2" name="Delivery Premise Type" headerClass="header" [width]="180" [cellClass]="getCellClass" *ngIf="is_premise_type">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-PREMISE_TYPE2'] = true"
              *ngIf="!editing[rowIndex + '-PREMISE_TYPE2'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-PREMISE_TYPE2'] = true"
              *ngIf="!editing[rowIndex + '-PREMISE_TYPE2'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <select *ngIf="editing[rowIndex + '-PREMISE_TYPE2']" (change)="updateValue($event, 'PREMISE_TYPE2', rowIndex)" (keyup)="updateValue($event, 'PREMISE_TYPE2', rowIndex)"
              (blur)="updateValue($event, 'PREMISE_TYPE2', rowIndex)" (keydown.enter)="$event.target.blur();updateValue($event, 'PREMISE_TYPE2', rowIndex);false">
              <option *ngFor="let pt of premise_types" [value]="pt.name">{{pt.name}}</option>
            </select>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="TAIL_LIFT2" name="Delivery Tail Lift" headerClass="header" [width]="180" [cellClass]="getCellClass" *ngIf="is_tail_lift">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-TAIL_LIFT2'] = true"
              *ngIf="!editing[rowIndex + '-TAIL_LIFT2'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-TAIL_LIFT2'] = true"
              *ngIf="!editing[rowIndex + '-TAIL_LIFT2'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <select *ngIf="editing[rowIndex + '-TAIL_LIFT2']" (change)="updateValue($event, 'TAIL_LIFT2', rowIndex)" (keyup)="updateValue($event, 'TAIL_LIFT2', rowIndex)"
              (blur)="updateValue($event, 'TAIL_LIFT2', rowIndex)" (keydown.enter)="$event.target.blur();updateValue($event, 'TAIL_LIFT2', rowIndex);false">
              <option value="">N/A</option>
              <option value="YES">Yes</option>
              <option value="NO">No</option>
            </select>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="ITEMS" name="Items" headerClass="header" [width]="180" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-ITEMS'] = true"
              *ngIf="!editing[rowIndex + '-ITEMS'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-ITEMS'] = true"
              *ngIf="!editing[rowIndex + '-ITEMS'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'ITEMS', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'ITEMS', rowIndex);false"
              *ngIf="editing[rowIndex + '-ITEMS']"
              type="number"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column prop="LENGTH" name="Length" headerClass="header" [width]="180" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-LENGTH'] = true"
              *ngIf="!editing[rowIndex + '-LENGTH'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-LENGTH'] = true"
              *ngIf="!editing[rowIndex + '-LENGTH'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'LENGTH', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'LENGTH', rowIndex);false"
              *ngIf="editing[rowIndex + '-LENGTH']"
              type="nubmer"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column prop="WIDTH" name="Width" headerClass="header" [width]="180" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-WIDTH'] = true"
              *ngIf="!editing[rowIndex + '-WIDTH'] && !isEmpty(value)"
            >{{ value }}</span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-WIDTH'] = true"
              *ngIf="!editing[rowIndex + '-WIDTH'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'WIDTH', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'WIDTH', rowIndex);false"
              *ngIf="editing[rowIndex + '-WIDTH']"
              type="number"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column prop="HEIGHT" name="Height" headerClass="header" [width]="180" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-HEIGHT'] = true"
              *ngIf="!editing[rowIndex + '-HEIGHT'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-HEIGHT'] = true"
              *ngIf="!editing[rowIndex + '-HEIGHT'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'HEIGHT', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'HEIGHT', rowIndex);false"
              *ngIf="editing[rowIndex + '-HEIGHT']"
              type="number"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column prop="WEIGHT" name="Weight" headerClass="header" [width]="180" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-WEIGHT'] = true"
              *ngIf="!editing[rowIndex + '-WEIGHT'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-WEIGHT'] = true"
              *ngIf="!editing[rowIndex + '-WEIGHT'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'WEIGHT', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'WEIGHT', rowIndex);false"
              *ngIf="editing[rowIndex + '-WEIGHT']"
              type="number"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column prop="DESCRIPTION" name="Packaging Type" headerClass="header" [width]="180" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-DESCRIPTION'] = true"
              *ngIf="!editing[rowIndex + '-DESCRIPTION'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-DESCRIPTION'] = true"
              *ngIf="!editing[rowIndex + '-DESCRIPTION'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'DESCRIPTION', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'DESCRIPTION', rowIndex);false"
              *ngIf="editing[rowIndex + '-DESCRIPTION']"
              type="text"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column prop="INSTRUCTIONS" name="Instructions" headerClass="header" [width]="180" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-INSTRUCTIONS'] = true"
              *ngIf="!editing[rowIndex + '-INSTRUCTIONS'] && !isEmpty(value)"
            >
              {{ value }}&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-INSTRUCTIONS'] = true"
              *ngIf="!editing[rowIndex + '-INSTRUCTIONS'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'INSTRUCTIONS', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'HEIGHT', rowIndex);false"
              *ngIf="editing[rowIndex + '-INSTRUCTIONS']"
              type="text"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column prop="REFERENCE" name="Docket Nos." headerClass="header" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-REFERENCE'] = true"
              *ngIf="!editing[rowIndex + '-REFERENCE'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-REFERENCE'] = true"
              *ngIf="!editing[rowIndex + '-REFERENCE'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'REFERENCE', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'REFERENCE', rowIndex);false"
              *ngIf="editing[rowIndex + '-REFERENCE']"
              type="text"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column prop="PRICE" name="PRICE" headerClass="header" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-PRICE'] = true"
              *ngIf="!editing[rowIndex + '-PRICE'] && !isEmpty(value)"
            >
            ${{ ((value != null || value != 0) ? (value) : 0) | number:'4.2-2'}}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-PRICE'] = true"
              *ngIf="!editing[rowIndex + '-PRICE'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'PRICE', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'PRICE', rowIndex);false"
              *ngIf="editing[rowIndex + '-PRICE']"
              type="text"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column prop="FUEL" name="FUEL LEVY" headerClass="header" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-FUEL'] = true"
              *ngIf="!editing[rowIndex + '-FUEL'] && !isEmpty(value)"
            >{{ value }}%</span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-FUEL'] = true"
              *ngIf="!editing[rowIndex + '-FUEL'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'FUEL', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'FUEL', rowIndex);false"
              *ngIf="editing[rowIndex + '-FUEL']"
              type="text"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column prop="SERVICE" name="SERVICE FEE" headerClass="header" [cellClass]="getCellClass" >
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-SERVICE'] = true"
              *ngIf="!editing[rowIndex + '-SERVICE'] && !isEmpty(value)"
            >{{ value }}%</span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-SERVICE'] = true"
              *ngIf="!editing[rowIndex + '-SERVICE'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <input
              autofocus
              (blur)="updateValue($event, 'SERVICE', rowIndex)"
              (keydown.enter)="$event.target.blur();updateValue($event, 'SERVICE', rowIndex);false"
              *ngIf="editing[rowIndex + '-SERVICE']"
              type="text"
              [value]="value"
            />
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="DGTYPE" name="DG Type" headerClass="header" [width]="180" [cellClass]="getCellClass" *ngIf="is_dg">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-DGTYPE'] = true"
              *ngIf="!editing[rowIndex + '-DGTYPE'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-DGTYPE'] = true"
              *ngIf="!editing[rowIndex + '-DGTYPE'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <select *ngIf="editing[rowIndex + '-DGTYPE']" (change)="updateValue($event, 'DGTYPE', rowIndex)" (keyup)="updateValue($event, 'DGTYPE', rowIndex)"
              (blur)="updateValue($event, 'DGTYPE', rowIndex)" (keydown.enter)="$event.target.blur();updateValue($event, 'DGTYPE', rowIndex);false">
              <option value="">N/A</option>
              <option *ngFor="let dt of dg_types" [value]="dt.name">{{dt.name}}</option>
            </select>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="DGCLASS" name="DG Class" headerClass="header" [width]="180" [cellClass]="getCellClass" *ngIf="is_dg">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span
              title="Double click to edit"
              (dblclick)="editing[rowIndex + '-DGCLASS'] = true"
              *ngIf="!editing[rowIndex + '-DGCLASS'] && !isEmpty(value)"
            >
              {{ value }}
            </span>
            <a title="Click to add"
              (click)="editing[rowIndex + '-DGCLASS'] = true"
              *ngIf="!editing[rowIndex + '-DGCLASS'] && isEmpty(value)">
              <i class="fa fa-sm fa-plus"></i></a>
            <select *ngIf="editing[rowIndex + '-DGCLASS']" (change)="updateValue($event, 'DGCLASS', rowIndex)" (keyup)="updateValue($event, 'DGCLASS', rowIndex)"
              (blur)="updateValue($event, 'DGCLASS', rowIndex)" (keydown.enter)="$event.target.blur();updateValue($event, 'DGCLASS', rowIndex);false">
              <option value="">N/A</option>
              <option *ngFor="let dc of dg_classes" [value]="dc.description">{{dc.name}}-{{dc.description}}</option>
            </select>
          </ng-template>
        </ngx-datatable-column>
</ngx-datatable>

</div>

    <div *ngIf="importedData.length > 0" class="mt-2">
        <button class="btn btn-sm btn-danger w-200p mb-1"  [hidden]="submitted" (click)="processForm(importedData)"><span>Import All</span></button> &nbsp;
        <button type="button" [disabled]="!selected || selected.length < 0" class="btn btn-sm btn-secondary" (click)="processForm(selected)" >Import Selected</button> Total selected: {{selected.length}} 
    </div>
   


